var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header'),_c('section',{staticClass:"banner-03 iq-bg iq-bg-fixed iq-over-black-80",staticStyle:{"background":"url(assets/images/banner/bg.jpg)"},attrs:{"id":"iq-home"}}),_c('Content'),_c('Contact'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }